import { saveAs } from 'file-saver'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

import useFile from '@/features/files/useFile'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

// Replicates ViewFileButton/DownloadButton's logic as plain callbacks, since
// CategoryFileList (packages/ui) renders its own buttons and can't render
// client's React-Query-bound button components directly.
const useUserManualFileActions = () => {
  const { useDownloadFile } = useFile()
  const downloadFile = useDownloadFile()
  const dispatch = useDispatch()

  const handleView = async (file) => {
    try {
      dispatch(showLoadingOverlay())

      const response = await downloadFile.mutateAsync(file._id)
      const fileType = response.headers['content-type']

      if (fileType === 'application/pdf') {
        const blob = new Blob([response.data], { type: fileType })
        window.open(URL.createObjectURL(blob))
      } else {
        toast.error("This file type can't be preview, please download it instead.")
      }
    } catch (err) {
      toast.error(`${err}`)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  const handleDownload = async (file) => {
    try {
      dispatch(showLoadingOverlay())

      const response = await downloadFile.mutateAsync(file._id)
      const contentDisposition = response.headers['content-disposition']
      let fileName = file.originalFileName ?? 'e-approval-file'

      if (contentDisposition && contentDisposition.includes('filename=')) {
        fileName = contentDisposition.split('filename=')[1].replace(/"/g, '')
      }

      const blob = new Blob([response.data], { type: response.headers['content-type'] })
      saveAs(blob, fileName)
    } catch (err) {
      toast.error(`${err}`)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  return { handleView, handleDownload }
}

export default useUserManualFileActions
